import { libraryFilms } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function LibraryGrid() {
  return (
    <section id="library" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="NOW SHOWING"
          title="热映片单 · 大小卡混排"
          desc="大卡留给本周最值得看的，小卡装下你可能错过的惊喜。"
          actionLabel="换一批片单"
          actionHref="#ranking"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:auto-rows-[200px]">
          {libraryFilms.map((film, i) => {
            const isFeature = i === 0;
            return (
              <a
                key={film.id}
                href="#ranking"
                className={`group relative rounded-lg overflow-hidden border border-background-200 ${
                  isFeature
                    ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2 min-h-[320px] lg:min-h-0'
                    : 'min-h-[240px] lg:min-h-0'
                }`}
              >
                <img
                  src={film.image}
                  alt={`${film.title} 青春电影剧照`}
                  title={`${film.title} - 青苹果影院青春电影`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />

                <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-background-50/95 text-foreground-950 text-xs font-bold px-2 py-1 rounded-md">
                  <i className="ri-star-fill text-accent-500" />
                  {film.score}
                </span>
                {isFeature && (
                  <span className="absolute top-3 right-3 bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-md">
                    本周大卡
                  </span>
                )}

                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {film.tags.map((t) => (
                      <span
                        key={t}
                        className="text-[11px] text-background-100 bg-foreground-950/40 border border-background-100/30 px-2 py-0.5 rounded-full"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <h3
                    className={`font-bold text-background-50 leading-snug ${
                      isFeature ? 'text-xl md:text-2xl' : 'text-base'
                    }`}
                  >
                    {film.title}
                  </h3>
                  <p
                    className={`mt-1 text-background-200 ${
                      isFeature ? 'text-sm' : 'text-xs line-clamp-1'
                    }`}
                  >
                    {film.subtitle}
                  </p>
                  <div className="mt-2.5 flex items-center gap-3 text-xs text-background-200">
                    <span>{film.year}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-time-line" />
                      {film.duration}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {film.comments}
                    </span>
                  </div>
                </div>
              </a>
            );
          })}

          <a
            href="#category"
            className="min-h-[160px] lg:min-h-0 rounded-lg border border-dashed border-primary-400 bg-primary-50/70 flex flex-col items-center justify-center gap-2 hover:bg-primary-100 transition-colors"
          >
            <span className="w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xl" />
            </span>
            <span className="text-sm font-semibold text-primary-800">查看完整片库</span>
            <span className="text-xs text-foreground-500">12,860 部青春电影</span>
          </a>
        </div>
      </div>
    </section>
  );
}